export const categories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-apps-2-line" },
  { id: "korean", name: "韩漫", slug: "korean", icon: "ri-flag-2-line" },
  { id: "japanese", name: "日漫", slug: "japanese", icon: "ri-flag-line" },
  { id: "chinese", name: "国漫", slug: "chinese", icon: "ri-star-smile-line" },
  { id: "romance", name: "恋爱", slug: "romance", icon: "ri-heart-line" },
  { id: "action", name: "热血", slug: "action", icon: "ri-fire-line" },
  { id: "fantasy", name: "奇幻", slug: "fantasy", icon: "ri-magic-line" },
  { id: "comedy", name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line" },
  { id: "horror", name: "悬疑", slug: "horror", icon: "ri-ghost-line" },
  { id: "completed", name: "完结", slug: "completed", icon: "ri-check-double-line" },
];

export const comics = [
  {
    id: 1,
    title: "剑与魔法",
    author: "金泰亨",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20manhwa%20cover%20featuring%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20realm%2C%20dramatic%20lighting%2C%20vibrant%20warm%20orange%20and%20gold%20tones%2C%20manga%20style%20illustration%20with%20detailed%20background%2C%20cinematic%20composition&width=400&height=560&seq=comic-01&orientation=portrait",
    description: "在魔法与剑交织的世界里，少年艾伦踏上了成为最强剑士的征途。他拥有罕见的双重属性魔力，却因此被各方势力觊觎。在伙伴们的帮助下，艾伦逐渐揭开自己身世之谜，并发现了一个足以毁灭世界的惊天阴谋...",
    category: "fantasy",
    region: "korean",
    status: "连载中",
    rating: 9.5,
    views: 1280000,
    chapters: 156,
    updatedAt: "2026-08-02",
    tags: ["奇幻", "冒险", "热血", "韩漫"],
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 156, title: "第156话 最终的抉择", date: "2026-08-02" },
      { id: 155, title: "第155话 黑暗降临", date: "2026-07-30" },
      { id: 154, title: "第154话 友情的试炼", date: "2026-07-28" },
      { id: 153, title: "第153话 觉醒之力", date: "2026-07-25" },
      { id: 152, title: "第152话 远古遗迹", date: "2026-07-23" },
    ],
  },
  {
    id: 2,
    title: "霸道总裁的甜心秘书",
    author: "林初夏",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20manhwa%20cover%20featuring%20a%20beautiful%20woman%20in%20office%20attire%20and%20a%20handsome%20man%20in%20a%20suit%2C%20soft%20pink%20and%20warm%20tones%2C%20modern%20city%20background%2C%20shojo%20manga%20style%2C%20elegant%20composition&width=400&height=560&seq=comic-02&orientation=portrait",
    description: "刚毕业的苏小暖进入了一家顶级企业，却意外成为了冷酷总裁的私人秘书。原以为是地狱般的职场生活，却在朝夕相处中发现了总裁不为人知的温柔一面。一段甜蜜又虐心的办公室恋情就此展开...",
    category: "romance",
    region: "chinese",
    status: "连载中",
    rating: 9.2,
    views: 2560000,
    chapters: 89,
    updatedAt: "2026-08-03",
    tags: ["恋爱", "职场", "甜宠", "国漫"],
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 89, title: "第89话 心动的告白", date: "2026-08-03" },
      { id: 88, title: "第88话 雨中的约定", date: "2026-07-31" },
      { id: 87, title: "第87话 意外的吻", date: "2026-07-29" },
      { id: 86, title: "第86话 危机时刻", date: "2026-07-26" },
      { id: 85, title: "第85话 误会解除", date: "2026-07-24" },
    ],
  },
  {
    id: 3,
    title: "暗夜追踪者",
    author: "佐藤健一",
    cover: "https://readdy.ai/api/search-image?query=A%20thriller%20manga%20cover%20featuring%20a%20detective%20in%20a%20dark%20alley%20with%20neon%20lights%2C%20mysterious%20atmosphere%2C%20dark%20red%20and%20shadow%20tones%2C%20seinen%20manga%20style%2C%20noir%20aesthetic&width=400&height=560&seq=comic-03&orientation=portrait",
    description: "东京连续发生离奇失踪案件，警视厅精英刑警黑崎零介奉命调查。随着调查深入，他发现这背后牵扯到一个庞大的地下犯罪组织。在正义与黑暗的较量中，黑崎不得不面对自己过去的阴影...",
    category: "horror",
    region: "japanese",
    status: "连载中",
    rating: 9.7,
    views: 1890000,
    chapters: 67,
    updatedAt: "2026-08-01",
    tags: ["悬疑", "推理", "犯罪", "日漫"],
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 67, title: "第67话 真相大白", date: "2026-08-01" },
      { id: 66, title: "第66话 最后的线索", date: "2026-07-29" },
      { id: 65, title: "第65话 背叛者", date: "2026-07-27" },
      { id: 64, title: "第64话 地下迷宫", date: "2026-07-24" },
      { id: 63, title: "第63话 新的牺牲者", date: "2026-07-22" },
    ],
  },
  {
    id: 4,
    title: "异能学院",
    author: "张浩然",
    cover: "https://readdy.ai/api/search-image?query=A%20superpower%20school%20manhua%20cover%20featuring%20students%20with%20special%20abilities%20in%20a%20modern%20academy%2C%20vibrant%20energy%20effects%2C%20warm%20coral%20and%20teal%20tones%2C%20dynamic%20action%20pose%2C%20shonen%20style&width=400&height=560&seq=comic-04&orientation=portrait",
    description: "在一个人人都可能觉醒异能的时代，普通高中生叶凡意外进入了全国最顶尖的异能学院。在这里，他将遇到各怀绝技的同学们，经历一场又一场惊心动魄的冒险，一步步成长为最强的异能者...",
    category: "action",
    region: "chinese",
    status: "连载中",
    rating: 9.3,
    views: 3100000,
    chapters: 203,
    updatedAt: "2026-08-03",
    tags: ["热血", "校园", "异能", "国漫"],
    featured: false,
    isNew: true,
    chapters_list: [
      { id: 203, title: "第203话 巅峰对决", date: "2026-08-03" },
      { id: 202, title: "第202话 突破极限", date: "2026-07-31" },
      { id: 201, title: "第201话 联手作战", date: "2026-07-29" },
      { id: 200, title: "第200话 学院庆典", date: "2026-07-26" },
      { id: 199, title: "第199话 新的挑战", date: "2026-07-24" },
    ],
  },
  {
    id: 5,
    title: "搞笑一家人",
    author: "朴志浩",
    cover: "https://readdy.ai/api/search-image?query=A%20comedy%20slice%20of%20life%20manhwa%20cover%20featuring%20a%20funny%20family%20in%20daily%20chaos%2C%20bright%20warm%20yellow%20and%20orange%20palette%2C%20exaggerated%20expressions%2C%20humorous%20gag%20manga%20style&width=400&height=560&seq=comic-05&orientation=portrait",
    description: "四个性格迥异的兄弟姐妹和搞笑父母住在一起，每天上演着让人捧腹大笑的家庭喜剧。从早餐大战到深夜卧谈，从学校乌龙到邻里趣事，这家人的生活永远不会无聊...",
    category: "comedy",
    region: "korean",
    status: "完结",
    rating: 9.1,
    views: 4500000,
    chapters: 312,
    updatedAt: "2026-06-15",
    tags: ["搞笑", "日常", "家庭", "韩漫"],
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 312, title: "第312话 永远的一家人（终）", date: "2026-06-15" },
      { id: 311, title: "第311话 毕业典礼", date: "2026-06-12" },
      { id: 310, title: "第310话 爸爸的秘密", date: "2026-06-10" },
      { id: 309, title: "第309话 相亲大作战", date: "2026-06-07" },
      { id: 308, title: "第308话 家庭旅行", date: "2026-06-05" },
    ],
  },
  {
    id: 6,
    title: "前世今生缘",
    author: "宫崎花子",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20manga%20cover%20with%20a%20couple%20in%20traditional%20and%20modern%20clothing%20split%20scene%2C%20cherry%20blossoms%2C%20soft%20peach%20and%20gold%20tones%2C%20elegant%20shojo%20manga%20style&width=400&height=560&seq=comic-06&orientation=portrait",
    description: "千年前未能相守的爱人，在现代都市中重逢。她保留着前世的记忆，而他却已全然忘记。一段跨越时空的虐恋，当命运的齿轮再次转动，他们能否冲破重重阻碍，续写未完成的爱情故事...",
    category: "romance",
    region: "japanese",
    status: "完结",
    rating: 9.6,
    views: 3800000,
    chapters: 120,
    updatedAt: "2026-05-20",
    tags: ["恋爱", "奇幻", "转世", "日漫"],
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 120, title: "第120话 今生之约（终）", date: "2026-05-20" },
      { id: 119, title: "第119话 前世记忆", date: "2026-05-17" },
      { id: 118, title: "第118话 最后的考验", date: "2026-05-15" },
      { id: 117, title: "第117话 真相揭晓", date: "2026-05-12" },
      { id: 116, title: "第116话 命运重逢", date: "2026-05-10" },
    ],
  },
  {
    id: 7,
    title: "机械纪元2077",
    author: "李星辰",
    cover: "https://readdy.ai/api/search-image?query=A%20sci-fi%20manhua%20cover%20featuring%20a%20cyborg%20warrior%20in%20a%20futuristic%20cityscape%2C%20neon%20lights%2C%20warm%20amber%20and%20crimson%20tones%2C%20cyberpunk%20aesthetic%2C%20action%20pose&width=400&height=560&seq=comic-07&orientation=portrait",
    description: "2077年，人类与人工智能共存的世界。机械改造人凯恩在一次任务中发现了政府隐藏的巨大阴谋。为了揭开真相，他不得不与曾经的战友为敌，在钢铁丛林般的大都市中展开一场惊心动魄的逃亡...",
    category: "action",
    region: "chinese",
    status: "连载中",
    rating: 9.4,
    views: 2100000,
    chapters: 98,
    updatedAt: "2026-08-02",
    tags: ["科幻", "热血", "机甲", "国漫"],
    featured: false,
    isNew: true,
    chapters_list: [
      { id: 98, title: "第98话 系统入侵", date: "2026-08-02" },
      { id: 97, title: "第97话 地下抵抗军", date: "2026-07-30" },
      { id: 96, title: "第96话 记忆碎片", date: "2026-07-28" },
      { id: 95, title: "第95话 生死时速", date: "2026-07-25" },
      { id: 94, title: "第94话 觉醒", date: "2026-07-23" },
    ],
  },
  {
    id: 8,
    title: "梦幻餐厅",
    author: "崔美英",
    cover: "https://readdy.ai/api/search-image?query=A%20food-themed%20manhwa%20cover%20featuring%20a%20chef%20presenting%20a%20beautiful%20dish%2C%20warm%20kitchen%20atmosphere%2C%20rich%20golden%20and%20copper%20tones%2C%20slice%20of%20life%20manga%20style&width=400&height=560&seq=comic-08&orientation=portrait",
    description: "失业的美食评论家金多美意外继承了一家位于首尔小巷的老餐厅。在这里，她遇到了神秘的厨师长和一群各有故事的常客。用美食治愈人心，用料理传递温暖，这家不起眼的小店正在改变每个人的生活...",
    category: "comedy",
    region: "korean",
    status: "连载中",
    rating: 9.0,
    views: 980000,
    chapters: 45,
    updatedAt: "2026-08-01",
    tags: ["美食", "治愈", "日常", "韩漫"],
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 45, title: "第45话 招牌菜的秘密", date: "2026-08-01" },
      { id: 44, title: "第44话 美食评论家", date: "2026-07-29" },
      { id: 43, title: "第43话 深夜访客", date: "2026-07-27" },
      { id: 42, title: "第42话 竞争对手", date: "2026-07-24" },
      { id: 41, title: "第41话 奶奶的食谱", date: "2026-07-22" },
    ],
  },
  {
    id: 9,
    title: "鬼眼侦探社",
    author: "山下智久",
    cover: "https://readdy.ai/api/search-image?query=A%20supernatural%20horror%20manga%20cover%20with%20a%20person%20who%20can%20see%20ghosts%2C%20dark%20atmosphere%2C%20ethereal%20spirits%2C%20deep%20red%20and%20black%20tones%2C%20occult%20manga%20style&width=400&height=560&seq=comic-09&orientation=portrait",
    description: "拥有阴阳眼的大学生林晓晓，能看到常人看不到的东西。她开了一家不起眼的侦探社，专门处理灵异事件。每一个案件背后都藏着一个动人的故事，在解决事件的同时，她也在解开自己身上的谜团...",
    category: "horror",
    region: "japanese",
    status: "连载中",
    rating: 9.2,
    views: 1650000,
    chapters: 78,
    updatedAt: "2026-08-03",
    tags: ["灵异", "推理", "治愈", "日漫"],
    featured: false,
    isNew: true,
    chapters_list: [
      { id: 78, title: "第78话 医院怪谈", date: "2026-08-03" },
      { id: 77, title: "第77话 镜中之人", date: "2026-07-31" },
      { id: 76, title: "第76话 废弃教室", date: "2026-07-29" },
      { id: 75, title: "第75话 午夜来电", date: "2026-07-26" },
      { id: 74, title: "第74话 校园传说", date: "2026-07-24" },
    ],
  },
  {
    id: 10,
    title: "仙界快递员",
    author: "王小明",
    cover: "https://readdy.ai/api/search-image?query=A%20xianxia%20cultivation%20manhua%20cover%20featuring%20a%20young%20man%20in%20ancient%20Chinese%20robe%20with%20magical%20artifacts%2C%20floating%20mountains%2C%20warm%20jade%20and%20gold%20tones%2C%20traditional%20Chinese%20painting%20style&width=400&height=560&seq=comic-10&orientation=portrait",
    description: "普通快递员李凡意外获得了往返人仙两界的能力。他开始了一项特殊的兼职——为仙界送快递！从仙丹妙药到神兵利器，从灵宠坐骑到功法秘籍，什么都能送。然而这份工作远没有想象中那么简单...",
    category: "fantasy",
    region: "chinese",
    status: "连载中",
    rating: 9.1,
    views: 1750000,
    chapters: 134,
    updatedAt: "2026-08-02",
    tags: ["修仙", "搞笑", "奇幻", "国漫"],
    featured: false,
    isNew: false,
    chapters_list: [
      { id: 134, title: "第134话 天庭订单", date: "2026-08-02" },
      { id: 133, title: "第133话 快递大作战", date: "2026-07-30" },
      { id: 132, title: "第132话 神秘包裹", date: "2026-07-28" },
      { id: 131, title: "第131话 仙界618", date: "2026-07-25" },
      { id: 130, title: "第130话 五星好评", date: "2026-07-23" },
    ],
  },
  {
    id: 11,
    title: "血族之恋",
    author: "安七炫",
    cover: "https://readdy.ai/api/search-image?query=A%20vampire%20romance%20manhwa%20cover%20with%20a%20mysterious%20vampire%20man%20and%20a%20human%20woman%2C%20gothic%20atmosphere%2C%20deep%20wine%20red%20and%20black%20tones%2C%20moonlight%20scene%2C%20dark%20romance%20style&width=400&height=560&seq=comic-11&orientation=portrait",
    description: "普通女大学生韩素希偶然救下了一位神秘男子，却发现他竟是活了三百年的吸血鬼贵族。命运的齿轮开始转动，一场跨越种族的禁忌之恋在月光下悄然绽放。然而吸血鬼猎人协会的追杀正在逼近...",
    category: "romance",
    region: "korean",
    status: "连载中",
    rating: 9.3,
    views: 2900000,
    chapters: 112,
    updatedAt: "2026-08-03",
    tags: ["恋爱", "吸血鬼", "奇幻", "韩漫"],
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 112, title: "第112话 血之契约", date: "2026-08-03" },
      { id: 111, title: "第111话 猎人来袭", date: "2026-07-31" },
      { id: 110, title: "第110话 古老家族", date: "2026-07-29" },
      { id: 109, title: "第109话 月光下的誓言", date: "2026-07-26" },
      { id: 108, title: "第108话 危险的诱惑", date: "2026-07-24" },
    ],
  },
  {
    id: 12,
    title: "武动苍穹",
    author: "陈昊",
    cover: "https://readdy.ai/api/search-image?query=An%20epic%20martial%20arts%20manhua%20cover%20with%20a%20warrior%20in%20dynamic%20battle%20pose%2C%20elemental%20energy%20effects%2C%20ancient%20Chinese%20landscape%2C%20warm%20fiery%20orange%20and%20crimson%20tones%2C%20wuxia%20style&width=400&height=560&seq=comic-12&orientation=portrait",
    description: "废柴少年林动偶然在祖传玉佩中发现了上古强者的传承。从此踏上逆天修行之路，拳碎山河，脚踏苍穹。在这个以武为尊的世界，他将用双拳打出一片属于自己的天地...",
    category: "action",
    region: "chinese",
    status: "完结",
    rating: 9.5,
    views: 5200000,
    chapters: 450,
    updatedAt: "2026-04-10",
    tags: ["热血", "玄幻", "战斗", "国漫"],
    featured: true,
    isNew: false,
    chapters_list: [
      { id: 450, title: "第450话 苍穹之主（终）", date: "2026-04-10" },
      { id: 449, title: "第449话 最终决战", date: "2026-04-07" },
      { id: 448, title: "第448话 巅峰境界", date: "2026-04-05" },
      { id: 447, title: "第447话 万界来朝", date: "2026-04-02" },
      { id: 446, title: "第446话 天道之秘", date: "2026-03-30" },
    ],
  },
];

export const featuredComics = comics.filter((c) => c.featured);

export const newComics = comics.filter((c) => c.isNew);

export const latestUpdates = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

export const completedComics = comics.filter((c) => c.status === "完结");

export function getComicsByCategory(slug: string) {
  if (slug === "all") return comics;
  if (slug === "completed") return completedComics;
  if (slug === "korean" || slug === "japanese" || slug === "chinese") {
    return comics.filter((c) => c.region === slug);
  }
  return comics.filter((c) => c.category === slug);
}

export function getComicById(id: number) {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(comic: typeof comics[0], limit: number = 4) {
  return comics
    .filter((c) => c.id !== comic.id && (c.category === comic.category || c.region === comic.region))
    .slice(0, limit);
}